var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('rect',{attrs:{"x":_vm.barStart,"width":_vm.barWidth,"height":"50"}}),_c('text',{staticClass:"country",attrs:{"y":"25","x":_vm.barStart - 10}},[_vm._v(" "+_vm._s(_vm.country)+" ")]),_c('text',{class:[
      'value',
      _vm.tweenedValue < _vm.tweenedMaxValue * 0.8 ? 'value--right' : 'value--left'
    ],attrs:{"y":"25","x":_vm.barStart + _vm.barWidth}},[_vm._v(" "+_vm._s(_vm._f("formatNumber")(_vm.valueAnimated ? _vm.tweenedValue : _vm.value))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }